import React from "react";

export default ({record}) => {
  return <span>Page {record.title ? `"${record.title}"` : ''}</span>;
}
